import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import MultiSelectBox from '../../../../../../../../../../features/components/Form/MultiSelectBox'

import {
  clearGetTikTokPurchaseIntentionCategories,
  getTikTokPurchaseIntentionCategories
} from '../../../../../../../../../../modules/actions/tikTokConstants'
import { selectedTikTokAdAccountSelector } from '../../../../../../../../../../modules/selectors/adAccounts'
import {
  getTikTokPurchaseIntentionCategoriesIsLoadingSelector,
  getTikTokPurchaseIntentionCategoriesSelector
} from '../../../../../../../../../../modules/selectors/tikTokConstants'

export const PURCHASE_INTENTION_KEYWORD_IDS = 'purchase_intention_keyword_ids'

const PurchaseIntentionCategoriesMultiselect = ({ formik, disabled = false }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { id: selectedAdAccountId } = useSelector(selectedTikTokAdAccountSelector)
  const purchaseIntentionCategories = useSelector(getTikTokPurchaseIntentionCategoriesSelector)
  const getTikTokPurchaseIntentionCategoriesIsLoading = useSelector(
    getTikTokPurchaseIntentionCategoriesIsLoadingSelector
  )

  const [searchValue, setSearchValue] = useState('')

  const additionalInterestOptions = useMemo(() => {
    return (
      purchaseIntentionCategories?.purchase_intention?.search_result?.[searchValue]?.map(item => ({
        ...item,
        value: item.id,
        label: item.name
      })) || []
    )
  }, [purchaseIntentionCategories, searchValue])

  const { values, setFieldValue } = formik

  const fetchCategoriesAndHashtags = useCallback(
    searchValue => {
      if (searchValue) {
        setSearchValue(searchValue)
        dispatch(
          getTikTokPurchaseIntentionCategories({
            account: selectedAdAccountId,
            search_keywords: [searchValue],
            sub_targeting_types: ['PURCHASE_INTENTION']
          })
        )
      }
    },
    [dispatch, selectedAdAccountId]
  )

  useEffect(() => {
    return () => {
      dispatch(clearGetTikTokPurchaseIntentionCategories())
      setSearchValue('')
    }
  }, [dispatch, selectedAdAccountId])

  return (
    <div>
      <MultiSelectBox
        onSearch={fetchCategoriesAndHashtags}
        placeholder={t('Purchase Intention Categories')}
        options={additionalInterestOptions}
        name={PURCHASE_INTENTION_KEYWORD_IDS}
        value={values[PURCHASE_INTENTION_KEYWORD_IDS]}
        isLoading={getTikTokPurchaseIntentionCategoriesIsLoading}
        setFieldValue={setFieldValue}
        isDisabled={disabled}
      />
    </div>
  )
}

export default PurchaseIntentionCategoriesMultiselect
